import {CheckoutTotalsSummaryQuery} from '@data/__generated__/types.main'

export default function showTip(preferences: CheckoutTotalsSummaryQuery['userPreferences']) {
  const {cart, store} = preferences
  const {acceptsTip} = cart

  const hideTip = store?.hideTip

  if (!acceptsTip || hideTip) return false

  return true
}
